import { env } from "../config/env";

const TENANT_LABEL_REGEX = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i;

export function isValidTenantLabel(value)
{
	return typeof value === "string" && TENANT_LABEL_REGEX.test(value);
}

export function buildDigitalLoginUrl(tenant)
{
	if(!isValidTenantLabel(tenant))
	{
		return null;
	}
	return "https://" + tenant + env.DIGITAL_URL;
}

export function readTenantFromStorage()
{
	if(typeof window === "undefined" || !window.localStorage)
	{
		return null;
	}
	return window.localStorage.getItem("tenant");
}

export function redirectToDigitalLogin()
{
	const tenant = readTenantFromStorage();
	const url = buildDigitalLoginUrl(tenant);
	if(url === null)
	{
		console.warn("[safeRedirect] tenant from localStorage failed validation, redirect aborted");
		return false;
	}
	window.location.href = url;
	return true;
}
